module.exports = __webpack_public_path__ + "static/media/diner-club.711eb049.png";